/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Offline_Resume_BodyInputs */



/**
* | output |
* | --- |
* | "Wundo carries on recording with this device's microphone. Everything recorded so far is kept — whatever was said in between is gone." |
*
* @param {Meeting_Offline_Resume_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_offline_resume_body = /** @type {((inputs?: Meeting_Offline_Resume_BodyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Offline_Resume_BodyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Wundo neemt verder op met de micro van dit toestel. Wat al opgenomen is, blijft bewaard — wat tussenin gezegd is, is weg.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Wundo continue d'enregistrer avec le micro de cet appareil. Tout ce qui est déjà enregistré est conservé — ce qui a été dit entre-temps est perdu.")
	return /** @type {LocalizedString} */ ("Wundo carries on recording with this device's microphone. Everything recorded so far is kept — whatever was said in between is gone.")
});